import React from "react";
import { Button, Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";

import styles from "../TripView.module.css";

const statusMap = {
  PUBLISHED: { type: "active", iconName: "iconCheck", labelKey: "commons.states.published" },
  ARCHIVED: { type: "inactive", iconName: "iconPlugs", labelKey: "commons.states.archived" },
  WAITING_FOR_APPROVAL: { type: "pending", iconName: "iconWarning", labelKey: "commons.states.waiting" },
  DRAFTS: { type: "inactive", iconName: "iconPlugs", labelKey: "commons.states.darft" },
};

const TripViewHeader = ({ publicationId, status, tripReference, onEdit, onBack, onOpenPublication }) => {
  const { t } = useTranslation();
  const statusConfig = statusMap[status] || statusMap.DRAFTS;
  const isDraft = status === "DRAFTS";

  return (
    <header className={styles.header}>
      <div className={styles.headerIdentity}>
        <Text as="h3" size="lg" weight="semibold" className={styles.headerTitle}>
          {t("tripPublication.tripView.labels.viewTitle", { defaultValue: "Visualisation du voyage" })}
        </Text>
        <div className={styles.headerMetaRow}>
          <span className={styles.marketplaceBadge}>{tripReference || publicationId || "-"}</span>
          <span className={[styles.headerStatusChip, styles[`status${statusConfig.type}`]].join(" ")}>
            {t(statusConfig.labelKey)}
          </span>
        </div>
      </div>

      <div className={styles.headerActions}>
        <Button
          size="small"
          variant="secondary"
          iconName="iconArrowLeft"
          iconPosition="left"
          label={t("tripPublication.tripView.actions.backToCircuits")}
          onClick={onBack}
        />

        {isDraft && (
          <>
            <Button
              size="small"
              variant="primary"
              iconName="iconPenToSquare"
              iconPosition="left"
              label={t("tripPublication.tripView.actions.editTrip")}
              onClick={onEdit}
            />
            <Button
              size="small"
              variant="secondary"
              iconName="iconCheck"
              iconPosition="left"
              label={t("tripPublication.tripView.actions.openPublication", {
                defaultValue: "Publication",
              })}
              onClick={onOpenPublication}
            />
          </>
        )}
      </div>
    </header>
  );
};

export default TripViewHeader;
